import PropTypes from 'prop-types';
import classNames from 'classnames';
import Candidate from '../../../candidatesList/candidate';
import { formatTimeAgo } from '../../../../../utility/dateUtils';
import useStyles from '../styles';

const DELETED_USER_ID = 'deleted-user';

const EventAuthor = ({ translations, record }) => {
  const classes = useStyles();
  const daysAgo = formatTimeAgo(record.created_at, translations.candidates);
  const isDeletedUser = !record.author;
  const author = record.author || {
    ...translations.deletedUser,
    id: DELETED_USER_ID,
  };

  return (
    <Candidate
      className={classNames(classes.candidate, classes.authorAvatar)}
      user={author}
      label={daysAgo}
      anonymousUser={isDeletedUser}
      hasLabel
    />
  );
};

EventAuthor.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default EventAuthor;
